/**
 * Renders a heading's words unchanged, with the `accent` word/phrase set in
 * italic light blue. Used on the homepage only (opt-in via the `accent` prop).
 */
export const AccentTitle = ({ title, accent }) => {
  const i = title.indexOf(accent);
  if (i < 0) return title;
  return (
    <>
      {title.slice(0, i)}
      <em data-testid="heading-accent" className="font-serif italic text-accentblue">
        {accent}
      </em>
      {title.slice(i + accent.length)}
    </>
  );
};
